
<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="route.meta.keepAlive" :key="route.name"></component>
    </keep-alive>
    <component :is="Component" v-if="!route.meta.keepAlive" :key="route.name"></component>
  </router-view>
</template>
<script setup>
import { useRouter, useRoute } from 'vue-router'
const route = useRoute()
const router = useRouter()
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f4f6fb;
  -webkit-overflow-scrolling: touch;

}


</style>
